import { Link } from "react-router-dom";
import { H4 } from "../../../AbstractElements";
import CustomerAction from "../ActionCell/CustomerAction";
import ServiceAction from "../ActionCell/ServiceAction";

export const CustomerArchiveColumns = (authState,handleStatusChange) => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px',
        center: true,
    },
     {
        name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
        selector: row => row.action,
        cell: row => <CustomerAction row={row} authState={authState} handleStatusChange={handleStatusChange}  />,
        center: true,
        width: '55px',
    },
    {
        name: <H4>Customer Id</H4>,
        id: 'subscriber_id',
        selector: row => row.subscriber_id,
        sortable: true,
        wrap: true,
        // width: '140px',
        cell: row => (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.id}`}>
                {row.subscriber_id}
            </Link> : row.subscriber_id,
    },
    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.name,
        sortable: true,
        // width: '160px',
        wrap: true
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Date,
        // width: '100px',
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status}
            </span>
        ),
    },
   
    {
        name: <H4>Mobile No</H4>,
        selector: row => row.Mobile,
        id: 'mobile',
        sortable: true,
        // width: '160px',
    },
   
    {
        name: <H4>Address</H4>,
        selector: row => row.Address,
        id: 'address',
        sortable: true,
        // width: '180px',
        wrap: true,
    },
   
];

export const CustomerColumns = (authState, handleStatusChange, handlestatusArchive) => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px',
        center: true,
    },
    {
        name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
        selector: row => row.action,
        cell: row => <CustomerAction row={row} authState={authState} handleStatusChange={handleStatusChange} handlestatusArchive={handlestatusArchive} />,
        center: true,
        width: '55px',
    },
    {
        name: <H4>Customer ID</H4>,
        id: 'subscriber_id',
        selector: row => row.subscriber_id,
        sortable: true,
        wrap: true,
        minWidth: '140px',
        cell: row => (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.id}`}>
                {row.subscriber_id}
            </Link> : row.subscriber_id,
    },
    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.name,
        sortable: true,
        minWidth: '140px',
        wrap: true
    },
   
    {
        name: <H4>Mobile No</H4>,
        selector: row => row.Mobile,
        id: 'mobile',
        sortable: true,
        minWidth: '160px',
    },
    
    {
        name: <H4>Address</H4>,
        selector: row => row.Address,
        id: 'address',
        sortable: true,
        wrap: true,
        minWidth: '140px',

    },
     {
        name: <H4>Status</H4>,
        selector: row => row.Date,
        minWidth: '100px',
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status}
            </span>
        ),
    },
    
];
export const ServiceAccountColumns = (authState, Action) => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.si,
        width: '70px',
        center: true,
    },
    {
        name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
        selector: row => row.action,
        cell: row => <Action row={row}  />,
        center: true,
        width: '55px',
    },
    {
        name: <H4>Service Account ID</H4>,
        id: 'stb_no',
        selector: row => row.serviceAccId,
        sortable: true,
        wrap: true,
        minWidth: '200px',
        cell: row => (authState?.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/show-service-account?id=${row.id}`}>
                {row.serviceAccId}
            </Link> : row.serviceAccId,
    },
    {
        name: <H4>Account Name</H4>,
        id: 'stb_name',
        selector: row => row.stbName,
        sortable: true,
        minWidth: '140px',
        wrap: true,
    },
    {
        name: <H4>Service Plan Name</H4>,
        id: 'service_plan_name',
        selector: row => row.servicePlanName,
        sortable: true,
        minWidth: '160px',
        wrap: true,
    },
    {
        name: <H4>Last Service Date</H4>,
        id: 'last_service_date',
        selector: row => row.lastServiceDate,
        sortable: true,
        minWidth: '160px',
        wrap: true,
    },
    {
        name: <H4>Next Due Date</H4>,
        id: 'next_service_due_date',
        selector: row => row.nextDueDate,
        sortable: true,
        minWidth: '140px',
        wrap: true,
    },
    {
        name: <H4>Customer Name</H4>,
        id: 'customer_name',
        selector: row => row.name,
        sortable: true,
        minWidth: '140px',
        wrap: true,
        cell: row => (authState?.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customerId}`}>
                {row.name}
            </Link> : row.name,
    },
    {
        name: <H4>Service Address</H4>,
        id: 'service_address',
        selector: row => row.serviceAddress,
        sortable: true,
        width: '140px',
        wrap: true
    },
    {
        name: <H4>Area</H4>,
        selector: row => row.area,
        id: 'area_name',
        sortable: true,
    },
    // {
    //     name: <H4>Purchased Date</H4>,
    //     selector: row => row.purchaseDate,
    //     id: 'address',
    //     sortable: true,
    //     width: '160px',
    //     wrap: true,
    // },
    {
        name: <H4>Product Name</H4>,
        selector: row => row.productName,
        minWidth: '140px',
        warap:true
    },
     {
        name: <H4>Status</H4>,
        selector: row => row.status,
        minWidth: '100px',
        cell: row => (
            <span
                className={`badge badge-${row.status}`}
            >
                {row.status}
            </span>
        ),
    },
];
export const ServiceHistoryColumns = () => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px',
        center: true,

    },
    {
        name: <H4>Service Plan</H4>,
        id: 'service_type',
        selector: row => row.subscriber_id,
        sortable: true,
        wrap: true,
        width: '140px',
    },
    {
        name: <H4>Date</H4>,
        id: 'date',
        selector: row => row.name,
        sortable: true,
        width: '140px',
        wrap: true
    },
    {
        name: <H4>Next Service Date</H4>,
        id: 'next_serivce_date',
        selector: row => row.name,
        sortable: true,
        width: '190px',
        wrap: true
    },
    {
        name: <H4>Staff Name</H4>,
        selector: row => row.Area,
        id: 'area',
        sortable: true,
    },
    {
        name: <H4>Invoice</H4>,
        selector: row => row.Address,
        id: 'address',
        sortable: true,
        width: '160px',
        wrap: true,
    },
   
     {
        name: <H4>Status</H4>,
        selector: row => row.Date,
        width: '100px',
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status}
            </span>
        ),
    },
];
export const ServiceComplaintColumns = () => [
  {
    name: <H4>Sl.No</H4>,
    selector: row => row.si,
    width: '70px',
    center: true,
  },
  {
    name: <H4>Date</H4>,
    id: 'date',
    selector: row => row.date,
    sortable: true,
    wrap: true,
    minWidth: '150px',
  },
  {
    name: <H4>Problem Type</H4>,
    id: 'problemType',
    selector: row => row.problemType,
    sortable: true,
    minWidth: '200px',
    wrap: true,
  },
  {
    name: <H4>Payment Status</H4>,
    id: 'paymentStatus',
    selector: row => row.paymentStatus,
    sortable: true,
    minWidth: '200px',
    wrap: true,
  },
  {
    name: <H4>Details</H4>,
    id: 'details',
    selector: row => row.details,
    sortable: true,
    minWidth: '200px',
    wrap: true,
  },
  {
    name: <H4>Staff Name</H4>,
    selector: row => row.staff,
    id: 'staffName',
    sortable: true,
    minWidth: '160px',

  },
  {
    name: <H4>Status</H4>,
    selector: row => row.status,
    minWidth: '100px',
    cell: row => (
      <span className={`badge badge-${row.status}`}>
        {row.status}
      </span>
    ),
  },
];


export const StbColumns = (authState, Action) => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px',
        center: true,
    },
    {
        name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
        selector: row => row.action,
        cell: row => <Action row={row} />,
        center: true,
        width: '70px',
    },
    {
        name: <H4>Subscriber Id</H4>,
        id: 'subscriber_id',
        selector: row =>
            (authState.userRole === 1 || authState.permissions.includes("show-customer-profile")) ?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customer_id}`}>
                    {row.Sub}
                </Link> : row.Sub,
        sortable: true,
        wrap: true,
        width: '100px',
    },
    {
        name: <H4>Name</H4>,
        id: 'customer_name',
        selector: row => row.Name,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        width: '100px',
        cell: row => (
            <div>
                <span
                    className={`badge badge-${row.Status}`}
                >
                    {row.Status}
                </span>
                {row.Status === 'disconnected' && (
                    <span>{row.StatusDate}</span>
                )}
            </div>
        ),
    },
    {
        name: <H4>Connection Type</H4>,
        id: 'connection_type',
        selector: row => row.ConnectType,
        sortable: true,
        width: '110px',
    },
    {
        name: <H4>Serial No</H4>,
        id: 'serial_no',
        selector: row => row.Serial,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Stb Type</H4>,
        id: 'type',
        selector: row => row.StbType,
        sortable: true,
        width: '70px',
    },
    {
        name: <H4>STB No</H4>,
        id: 'stb_no',
        selector: row => row.StbNo,
        sortable: true,
        width: '100px',
    },
    {
        name: <H4>Install Date</H4>,
        id: 'activated_at',
        selector: row => row.Date,
        sortable: true,
        width: '130px',
        wrap: true
    },
    {
        name: <H4>Cas Provider</H4>,
        id: 'provider_name',
        selector: row => row.Cas,
        sortable: true,
    },
];